import { Component } from '@angular/core'
import { Store } from '@ngrx/store'
import { selectProfileState } from '../../../user-profile.state'
import { Observable } from 'rxjs'

@Component({
  selector: 'cover-forgot-password-email-sent',
  templateUrl: './forgot-password-email-sent.component.html',
  styleUrls: ['./forgot-password-email-sent.component.scss'],
})
export class ForgotPasswordEmailSentComponent {
  emailState$: Observable<string>

  constructor(private readonly store: Store) {
    this.emailState$ = this.store.select(selectProfileState.emailState)
  }
}
